import { render } from "./GlobalAlert.vue?vue&type=template&id=1a56ca66&scoped=true&ts=true"
import script from "./GlobalAlert.vue?vue&type=script&lang=ts"
export * from "./GlobalAlert.vue?vue&type=script&lang=ts"

import "./GlobalAlert.vue?vue&type=style&index=0&id=1a56ca66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a56ca66"]])

export default __exports__